//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import SfHeroItem from "./_internal/SfHeroItem.vue";
import SfArrow from "../../atoms/SfArrow/SfArrow.vue";
import SfBullets from "../../atoms/SfBullets/SfBullets.vue";
import Glide from "@glidejs/glide";
Vue.component("SfHeroItem", SfHeroItem);
export default {
  name: "SfHero",
  components: {
    SfArrow,
    SfBullets,
  },
  props: {
    sliderOptions: {
      type: Object,
      default: () => ({}),
    },
    autoPlay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      glide: null,
      defaultOptions: {
        type: "slider",
        rewind: true,
        autoplay: this.autoPlay,
        perView: 1,
        gap: 0,
      },
    };
  },
  computed: {
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.sliderOptions,
      };
    },
    numberOfPages() {
      return this.$slots.default
        ? this.$slots.default.filter((slot) => slot.tag).length
        : 0;
    },
    page() {
      if (this.glide) {
        return this.glide.index + 1;
      }
      return 1;
    },
  },
  mounted() {
    if (this.numberOfPages > 1) {
      this.$nextTick(() => {
        if (!this.$slots.default) return;
        const glide = new Glide(this.$refs.glide, this.mergedOptions);
        glide.mount();
        glide.on("run.after", () => {
          this.applyA11yFix();
        });
        this.glide = glide;
        this.applyA11yFix();
      });
    }
  },
  methods: {
    go(direct) {
      if (!this.glide) return;
      switch (direct) {
        case "prev":
          this.glide.go("<");
          break;
        case "next":
          this.glide.go(">");
          break;
        default:
          this.glide.go(`=${direct}`);
          break;
      }
    },
    applyA11yFix() {
      this.$nextTick(() => {
        if (!this.glide) return;

        const allSlides = this.$el.querySelectorAll(".glide__slide");
        const activeSlide = this.$el.querySelector(".glide__slide--active");

        allSlides.forEach((slide) => {
          if (slide === activeSlide) {
            slide.removeAttribute("aria-hidden");
            slide.removeAttribute("tabindex");
            slide.querySelectorAll(
              'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
            ).forEach((el) => {
              el.removeAttribute("aria-hidden");
              el.removeAttribute("tabindex");
            });
          } else {
            slide.setAttribute("aria-hidden", "true");
            slide.setAttribute("tabindex", "-1");
            slide.querySelectorAll(
              'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
            ).forEach((el) => {
              el.setAttribute("aria-hidden", "true");
              el.setAttribute("tabindex", "-1");
            });
          }
        });
      });
    }
  },
};
